export interface DataGridAction {
  description: string;
  class: string;
  onAction: (entity: any) => void;
  visible: (entity: any) => boolean;
}
